//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import aos from "~/mixins/aos.js";
import foretell from "~/mixins/foretell.js";
import schemaHelpers from "~/mixins/schema-helpers.js"; // Add this import

export default {
  data() {
    return {
      showCommercial: false,
    };
  },
  mixins: [aos, foretell, schemaHelpers], // Add schemaHelpers to the mixins array

  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", {
        lander_test: "bp:real-estate",
      });
    }
  },
  head() {
    if (this.pageInfo && this.metaInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain;
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "real-estate-new", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.log(e);
        error({ message: "Error fetching data..." });
        return {
          loading: false,
          // error: true,
        };
      });
  },
  computed: {
    hasSubscriptionAccess() {
      return this.$store.state.user.data.subscriptionAccess;
    },
    landlordDocs() {
      if (this.landlords) {
        let docs = this.landlords.table.residential_docs.concat(
          this.landlords.table.commercial_docs
        );
        return docs;
      }
    },
    hero() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.hero;
    },
    landlords() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.landlords;
    },
    transfers() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.transfers;
    },
    guide() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.guide;
    },
    tenants() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.tenants;
    },
    footercta() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.footer_cta;
    },
    metaInfo() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.meta_information.table;
    },
    tenancies() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.tenancies;
    },
  },
  jsonld() {
    if (!this.loading || !this.error) {
      return [
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": "https://www.legalnature.com/real-estate",
          },
          headline: this.metaInfo.title,
          description: this.metaInfo.description,
          image: this.metaInfo["og-image"],
          url: "https://www.legalnature.com/real-estate",
          author: this.schemaAuthor,
          logo: this.schemaLogo,
          publisher: {
            "@type": "Organization",
            name: "LegalNature",
            logo: this.schemaLogo,
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Homepage",
              item: "https://www.legalnature.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Real Estate",
              item: "https://www.legalnature.com/real-estate",
            },
          ],
        },
      ];
    }
  },
};
